module.exports = __webpack_public_path__ + "static/media/logo.aa9b8dce.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo.png
// module id = 345
// module chunks = 0